module.exports = __webpack_public_path__ + "img/16.f2bd2da5.jpg";